(function () {
  function resolveCSSVar(varName, fallback) {
    var raw = getComputedStyle(document.documentElement).getPropertyValue(varName).trim();
    if (!raw) return fallback;
    if (raw.indexOf('px') !== -1) return parseFloat(raw);
    if (raw.indexOf('rem') !== -1) {
      return parseFloat(raw) * parseFloat(getComputedStyle(document.documentElement).fontSize);
    }
    return parseFloat(raw) || fallback;
  }

  function MasonryLayout(container) {
    this.container = container;
    this.loadingEl = container.parentElement && container.parentElement.querySelector('.masonry-loading');
    this.itemSelector = container.dataset.masonryItem || '.blog-articles__article';
    this.resizeTimer = null;
    this.scrollTicking = false;

    // Infinite scroll is opt-in: only when the container explicitly carries
    // a data-next-url attribute (set by the blog list template).
    if (container.hasAttribute('data-next-url')) {
      this.nextUrl = container.dataset.nextUrl || '';
      if (!this.nextUrl && window.location.search.indexOf('page=') === -1) {
        var sep = window.location.search ? '&' : '?';
        this.nextUrl = window.location.pathname + window.location.search + sep + 'page=2';
      }
    } else {
      this.nextUrl = '';
    }

    this.run();
    this.observeImages(this.container);
    this.initInfiniteScroll();

    var self = this;
    window.addEventListener('resize', function () {
      clearTimeout(self.resizeTimer);
      self.resizeTimer = setTimeout(function () { self.run(); }, 150);
    });

    document.addEventListener('shopify:section:load', function () { self.run(); });
  }

  MasonryLayout.prototype.run = function () {
    var container = this.container;
    var items = Array.from(container.querySelectorAll(this.itemSelector));
    if (!items.length) return;

    var cols = window.innerWidth >= 750 ? 3 : 2;
    var hGap = window.innerWidth >= 750
      ? resolveCSSVar('--grid-desktop-horizontal-spacing', 20)
      : resolveCSSVar('--grid-mobile-horizontal-spacing', 10);
    var vGap = window.innerWidth >= 750
      ? resolveCSSVar('--grid-desktop-vertical-spacing', 20)
      : resolveCSSVar('--grid-mobile-vertical-spacing', 10);

    var containerWidth = container.offsetWidth;
    if (containerWidth === 0) return;

    var colWidth = (containerWidth - hGap * (cols - 1)) / cols;
    var colHeights = [];
    for (var i = 0; i < cols; i++) colHeights.push(0);

    items.forEach(function (item) {
      item.style.width = colWidth + 'px';
      item.style.position = 'absolute';

      var shortestCol = colHeights.indexOf(Math.min.apply(null, colHeights));
      item.style.left = (shortestCol * (colWidth + hGap)) + 'px';
      item.style.top = colHeights[shortestCol] + 'px';

      colHeights[shortestCol] += item.offsetHeight + vGap;
    });

    container.style.height = Math.max.apply(null, colHeights) + 'px';
  };

  // Re-run layout when individual images finish loading. Without this, an
  // image gallery built from <img> tags can lay out with 0-height items
  // before the browser knows their natural dimensions.
  MasonryLayout.prototype.observeImages = function (root) {
    var self = this;
    Array.from(root.querySelectorAll('img')).forEach(function (img) {
      if (img.complete && img.naturalHeight !== 0) return;
      img.addEventListener('load', function () { self.run(); }, { once: true });
      img.addEventListener('error', function () { self.run(); }, { once: true });
    });
  };

  MasonryLayout.prototype.initInfiniteScroll = function () {
    if (!this.nextUrl) return;

    var self = this;

    window.addEventListener('scroll', function () {
      if (self.scrollTicking) return;
      self.scrollTicking = true;

      requestAnimationFrame(function () {
        self.scrollTicking = false;

        if (!self.nextUrl || self.loading) return;

        var scrolledTo = window.scrollY + window.innerHeight;
        var pageHeight = document.documentElement.scrollHeight;

        if (scrolledTo >= pageHeight - (window.innerHeight * 1.5)) {
          self.loadNextPage();
        }
      });
    });
  };

  MasonryLayout.prototype.loadNextPage = function () {
    var self = this;
    self.loading = true;
    if (self.loadingEl) self.loadingEl.classList.add('is-loading');

    fetch(self.nextUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('No more pages');
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var newItems = Array.from(doc.querySelectorAll(self.itemSelector));

        if (!newItems.length) {
          self.nextUrl = '';
          self.loading = false;
          if (self.loadingEl) self.loadingEl.classList.remove('is-loading');
          return;
        }

        var fetchedContainer = doc.querySelector('[data-next-url]');
        self.nextUrl = fetchedContainer ? (fetchedContainer.dataset.nextUrl || '') : '';

        newItems.forEach(function (item) {
          item.classList.remove('scroll-trigger', 'animate--slide-in');
          item.removeAttribute('data-cascade');
          item.removeAttribute('style');
          self.container.appendChild(item);
          self.observeImages(item);
        });

        self.run();

        self.loading = false;
        if (self.loadingEl) self.loadingEl.classList.remove('is-loading');
      })
      .catch(function () {
        self.nextUrl = '';
        self.loading = false;
        if (self.loadingEl) self.loadingEl.classList.remove('is-loading');
      });
  };

  function initMasonry() {
    requestAnimationFrame(function () {
      var seen = [];
      document.querySelectorAll('.blog-articles--masonry, [data-masonry]').forEach(function (container) {
        if (seen.indexOf(container) !== -1) return;
        seen.push(container);
        new MasonryLayout(container);
      });
    });
  }

  if (document.readyState === 'complete') {
    initMasonry();
  } else {
    window.addEventListener('load', initMasonry);
  }
})();
